/*
 * @Description:
 * @Author: rongcheng
 * @@后台人员: xxx
 * @Date: 2022-05-05 10:46:13
 * @LastEditors: yyx
 * @LastEditTime: 2026-01-28 14:12:28
 */

import service from '@/utils/request'

export const getListAPI = (params: any) =>
  service.request({
    method: 'post',
    url: '/violationContractCheck/page',
    data: params
  })

// 企业下拉
export const getCompanyListAPI = (params: any) =>
  service.request({
    method: 'post',
    url: '/violationContractCheck/getCompanyList',
    data: params
  })

// 违章转移详情
export const subInfoAPI = (pramas: any) =>
  service.request({
    method: 'post',
    url: '/violationContractCheck/subInfo',
    data: pramas
  })

// 合同操作记录
export const violationContractOperateLogListAPI = (pramas: any) =>
  service.request({
    method: 'post',
    url: '/violationContractOperateLog/list',
    data: pramas
  })

// 提交资料审核
export const checkSubmitMaterialAPI = (pramas: any) =>
  service.request({
    method: 'post',
    url: '/violationContractCheck/checkSubmitMaterial',
    data: pramas
  })

// 待初审个数
export const getTransferCount = (pramas: any) =>
  service.request({
    method: 'post',
    url: '/violationContractCheck/getTransferCount',
    data: pramas
  })

// 重置待提交/待申请
export const editResetStatus = (pramas: any) =>
  service.request({
    method: 'post',
    url: '/violationContractCheck/editResetStatus',
    data: pramas
  })

// 管理员下拉框
export const dropdownOfEnterprise = (params: any) =>
  service.request({
    method: 'post',
    url: 'admin/enterprise/dropdownOfEnterprise',
    data: params
  })

// 重置提交次数
export const resetSubmitCount = (params: any) =>
  service.request({
    method: 'post',
    url: '/violationContractCheck/resetSubmitCount',
    data: params
  })

// 修改违章转移状态
export const editTransferStatus = (params: any) =>
  service.request({
    method: 'post',
    url: '/violationContractCheck/editTransferStatus',
    data: params
  })

// 更改备案状态
export const editViolationContractStatusAPI = (params: any) =>
  service.request({
    method: 'post',
    url: '/violationContractCheck/editViolationContractStatus',
    data: params
  })
